import {
  IsNumber,
  IsNumberString,
  MaxLength,
  MinLength
} from 'class-validator';

/**
 * Validation request for checking if employee has operator access to POS Device.
 */
export class PosValidateOperatorPinRequestDto {
  /**
   * Employee POS Access Pin
   */
  @IsNumberString()
  @MinLength(2)
  @MaxLength(8)
  public posAccessPin: string;

  /**
   * POS Device Id
   */
  @IsNumber()
  public posDeviceId: number;

  constructor(posAccessPin: string, posDeviceId: number) {
    this.posAccessPin = posAccessPin;
    this.posDeviceId = posDeviceId;
  }
}
